import { render, staticRenderFns } from "./StopDeparturesList.vue?vue&type=template&id=c8255f52&scoped=true"
import script from "./StopDeparturesList.vue?vue&type=script&lang=js"
export * from "./StopDeparturesList.vue?vue&type=script&lang=js"
import style0 from "./StopDeparturesList.vue?vue&type=style&index=0&id=c8255f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8255f52",
  null
  
)

export default component.exports